module.exports = __webpack_public_path__ + "img/financial-success.58a2518d.png";